import { getEnumValues } from './get-enum-values';
/**
 * Percentage: 0.13 to be treated as 13% and 13% will be added onto the total (x * (1 + amount))
 */
export enum FeeType{
	Percentage="percentage",
}
export const FeeTypeValues = getEnumValues<FeeType>(FeeType);